<template>
  <div>
    <zt-tooltip
      ref="ztItemTooltip"
      :text="item.text"
      position="right"
      :active="activeTooltipItem && isTruncated"
      class="w-full"
    >
      <div
        class="zt-dropdown-item zt-dropdown-item--link relative flex cursor-pointer items-center pl-12 pr-8 tracking-normal no-underline outline-none"
        :class="[{ 'item-divider': divider }]"
        ref="ztDropdownItem"
        @click="setValue(item)"
        :id="subItemId"
      >
        <span
          v-if="hasItemActive"
          class="absolute left-0 ml-3 text-zt-xs text-zt-primary-100"
        >
          <zt-icon name="check" />
        </span>
        <div
          class="zt-dropdown-item__content flex flex-wrap items-center self-center overflow-hidden py-3"
        >
          {{ getTextObject(item) }}
        </div>
      </div>
    </zt-tooltip>
    <transition name="show-item">
      <div
        v-if="hasItemActive && subMenu"
        class="inline-block h-full border-l bg-white px-4 py-2"
        ref="ztDropdownSubItem"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
import utils from '../../../../utils/helpers'
import { isEmpty, isEqual } from 'lodash'
import ztTooltip from '../ztTooltip/ztTooltip.vue'
import ztIcon from '../ztIcon/ztIcon.vue'

export default {
  name: 'ztDropdownItem',
  inheritAttrs: false,
  components: {
    ztTooltip,
    ztIcon,
  },
  inject: ['setItemSelected', 'activeTooltipItem', 'maxLength'],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    itemText: {
      type: [String, Array],
      default: '',
    },
    divider: {
      type: Boolean,
      default: false,
    },
    subMenu: {
      type: Boolean,
      default: false,
    },
    itemSelected: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showSubmenu: false,
      componentId: '',
    }
  },
  computed: {
    hasItemActive() {
      if (!isEmpty(this.itemSelected)) {
        return isEqual(this.item, this.itemSelected)
      }
      return false
    },
    subItemId() {
      return `sub-item-${this._uid}`
    },
    isTruncated() {
      return this.item.text.length > this.maxLength
    },
  },
  mounted() {
    this.componentId = this._uid.toString()
  },
  beforeDestroy() {
    const dropDownContainer = document.getElementById('subItemContainer')
    const dropDownSubItem = this.$refs.ztDropdownSubItem
    if (dropDownContainer && dropDownSubItem) {
      utils.removeContent(dropDownSubItem, dropDownContainer)
    }
  },
  methods: {
    getTextObject(item) {
      const text =
        this.itemText === ''
          ? utils.getPropertyItem(item, 'text')
          : utils.getPropertyItem(item, this.itemText)
      if (text.length > this.maxLength) {
        return text.slice(0, this.maxLength) + '...'
      }
      return text
    },
    async setValue(item) {
      this.setItemSelected(item)
      if (this.$refs.ztItemTooltip) {
        this.$refs.ztItemTooltip._mouseLeave()
      }
      if (this.subMenu) {
        await this.$nextTick()
        const dropDownContainer = document.getElementById('subItemContainer')
        const dropDownSubItem = this.$refs.ztDropdownSubItem
        if (dropDownSubItem && dropDownContainer) {
          utils.insertContent(dropDownSubItem, dropDownContainer)
        }
      }
    },
  },
}
</script>


